import { endOfDay } from 'date-fns';
import { getEndMonthDate } from '../../../../util';
import { getCustomCalendarPeriodEndDate } from '../../../../util/customCalendarPeriods';
import { ReportSettingWeightedAverageState } from '../WeightedAverage';
import { PITValidationData } from './validateReportSettingPITStateForReportType';

export const validateReportSettingPITStateWeightedAverage = ({
  pitAsOfDate,
  reportSettingState,
  customCalendarSettings,
}: PITValidationData): string[] => {
  const {
    asOf,
    isRunByTransitionDate,
  } = reportSettingState as ReportSettingWeightedAverageState;

  if (isRunByTransitionDate) return [];

  const isCustomCalendarEnabled =
    customCalendarSettings?.isCustomCalendarEnabled;

  const lastDate = isCustomCalendarEnabled
    ? getCustomCalendarPeriodEndDate(asOf, customCalendarSettings)
    : getEndMonthDate(asOf);
  const today = new Date();
  const formattedText = isCustomCalendarEnabled ? 'period' : 'month';

  const errs = [];
  if (endOfDay(pitAsOfDate) < endOfDay(lastDate)) {
    errs.push(
      `As of date cannot occur prior to the last day of the selected ${formattedText} and year. Please adjust dates or disable Point in Time.`,
    );
  }
  if (
    pitAsOfDate.getMonth() === today.getMonth() &&
    pitAsOfDate.getFullYear() === today.getFullYear()
  ) {
    errs.push(
      'As of date cannot occur in the same month and year as today’s date. Please adjust dates or disable Point in Time.',
    );
  }

  return errs;
};
